import { wtClientApi } from 'api/clients';

import type { GenericResponse } from 'commons/modules/generic-response';

import { PERSON_TYPE } from 'constants/globals';

import { removeEmptyParams } from 'utils/services';

import {
  adaptDataToGenericResponse,
  adaptErrorToGenericResponse,
} from '../shared';

import type { MoralClientDataDto, PhysicalClientDataDto } from './dto';
import {
  mapMoralClientDataDtoToModel,
  mapPhysicalClientDataDtoToModel,
} from './mappers';
import type { ClientDetailData, GetClientDetailParams } from './models';

const CLIENT_DETAIL_PATH = '/management/clients/';
const CLIENT_DETAIL_MORAL_PATH = '/management/clients/moral';

export const getClientDetail = async (
  params: GetClientDetailParams,
): Promise<GenericResponse<ClientDetailData>> => {
  try {
    const isMoral = params.taxPersonType === PERSON_TYPE.moral;
    const path = isMoral ? CLIENT_DETAIL_MORAL_PATH : CLIENT_DETAIL_PATH;

    const queryParams: Record<string, unknown> = {
      clientId: params.clientId,
      rfc: params.rfc,
    };
    removeEmptyParams(queryParams);

    if (isMoral) {
      const response = await wtClientApi.get<MoralClientDataDto>(path, {
        params: queryParams,
      });

      return adaptDataToGenericResponse(
        mapMoralClientDataDtoToModel(response.data),
        response.status,
      );
    }

    const response = await wtClientApi.get<PhysicalClientDataDto>(path, {
      params: queryParams,
    });

    return adaptDataToGenericResponse(
      mapPhysicalClientDataDtoToModel(response.data),
      response.status,
    );
  } catch (error: any) {
    return adaptErrorToGenericResponse(
      error,
      'Ocurrió un error al obtener los datos del cliente',
    );
  }
};
